import {ActionEnum} from "../action.enum";
import {DocumentGroupModel} from "../../models/document/document-group.model";


export namespace FilesDetailReleasedClassesAction {

  export class Initialize {
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_RELEASED_CLASSES_INITIALIZE;
    constructor (public version: DocumentGroupModel) {}
  }

  export class ChangeSelection {
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_RELEASED_CLASSES_CHANGE_SELECTION;
    constructor (public ids: Set<string>) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_RELEASED_CLASSES_SAVE;
    constructor () {}
  }

  export class ResetToInitialSelection{
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_RELEASED_CLASSES_RESET_TO_INITIAL_SELECTION;
    constructor () {}
  }
}
